import { render } from "./DeviceSensors.vue?vue&type=template&id=4ac2f4e7"
import script from "./DeviceSensors.vue?vue&type=script&lang=js"
export * from "./DeviceSensors.vue?vue&type=script&lang=js"
script.render = render

export default script